import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useRef, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Checkbox from "antd/es/checkbox/Checkbox";
import AddressesList from "./PersonalInformationDetails/AddressesList";
import { BookingsSectionTitle } from "./styles";
import PersonalBasicInformation from "./PersonalInformationDetails/PersonalBasicInformation";
import AliasesList from "./PersonalInformationDetails/AliasesList";
import TextField from "@/common/elements/InputElements/TextField";
import { Col, Row } from "react-bootstrap";
import { TableHeader } from "../InmateDetails/styles";
import VictimNotificationAttemptForm from "./VictimNotificationAttemptForm";
import FolderDetailSearchModal from "../FolderDetailSearch/FolderDetailSearchModal";
import { Form, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import Select from "@/common/elements/InputElements/Select";
import DynamicForm from "@/common/DynamicForm";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
  convertApiFields,
  getSQLTypeToHTMLType,
} from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { fetchExtraTableRecord } from "@/util/extraColumnActions";
import useDialog from "@/hooks/useDialog";
import CommonDatePicker from "@/common/elements/DatePicker";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
  SCHEMA_NAME,
} from "@/util/common_variable";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import FieldVerificationContext, {
  useFieldVerificationState,
} from "@/contexts/FieldVerificationContext";
import SecureFormItem from "@/common/SecureFormItem";
import VerificationHint from "@/common/VerificationHint";
import notificationService from "@/util/notificationService";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";
import { useVocabHeaders } from "@/hooks/useVocab";

// Phone headings are PCI's defaults; a site's Vocabulary rows rename them.
const VICTIM_NOTIFICATION_HEADERS = [
  { key: "status", text: "Status" },
  { key: "lName", text: "Last Name" },
  { key: "fName", text: "First Name" },
  { key: "mName", text: "Middle Name" },
  { key: "daytimePhone", text: "Daytime Phone" },
  { key: "phone", text: "Evening Phone" },
  { key: "comments", text: "Comments" },
];

const VICTIM_NOTIFICATION_LOG_HEADERS = [
  { key: "successful", text: "Successful" },
  { key: "methodLbl", text: "Method" },
  { key: "notifyingOfficerStaffID", text: "Staff Description" },
  { key: "dateNotified", text: "Date Notified" },
  { key: "timeNotified", text: "Time Notified" },
];

const VictimNotificationDetails = (startingPoint) => {
  const [victimNotificationForm] = Form.useForm();
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const verification = useFieldVerificationState("VictimNotification");

  // "Config" — drag-reorder/resize columns, persisted per-user (see
  // docs/plans/grid-column-config-feature.md). Two grids on this tab, two
  // independent configs — legacy ListIDs "VictimNotification" (the main
  // list) and "VictimNotificationLog" (the nested notification-attempts
  // log, confirmed in VictimNotificationInterface.asp).
  const {
    headers: victimNotificationHeaders,
    isConfiguring: isConfiguringVictimNotification,
    configButtonLabel: victimNotificationConfigLabel,
    startConfiguring: startConfiguringVictimNotification,
    confirmSave: confirmSaveVictimNotification,
    discardChanges: discardChangesVictimNotification,
    dataTableRef: victimNotificationTableRef,
  } = useGridColumnConfig("Bookings:VictimNotification", VICTIM_NOTIFICATION_HEADERS);
  const shownVictimNotificationHeaders = useVocabHeaders(victimNotificationHeaders);

  const {
    headers: victimNotificationLogHeaders,
    isConfiguring: isConfiguringVictimNotificationLog,
    configButtonLabel: victimNotificationLogConfigLabel,
    startConfiguring: startConfiguringVictimNotificationLog,
    confirmSave: confirmSaveVictimNotificationLog,
    discardChanges: discardChangesVictimNotificationLog,
    dataTableRef: victimNotificationLogTableRef,
  } = useGridColumnConfig(
    "Bookings:VictimNotificationLog",
    VICTIM_NOTIFICATION_LOG_HEADERS
  );

  const [showVictimNotifyTable, setShowVictimNotifyTable] = useState(false);
  const [showVictimNotification, setShowVictimNotification] = useState(false);
  const [notificationAttemptModal, setNotificationAttemptModal] =
    useState(false);
  const [isFolderSearchModal, setIsFolderSearchModal] = useState(false);
  const [victimNotifiTableList, setVictimNotifiTableList] = useState([]);
  const [victimNotificationID, setVictimNotificationID] = useState(null);
  const [victimLogID, setVictimLogID] = useState(null);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedVictimLog, setSelectedVictimLog] = useState(null);
  const [vicitimLogTable, setVictimLogTable] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  // -----------------------------------------------------------------------
  // VictimNotificationExtra — PCI's per-client dynamic "_U" columns for
  // this victim notification (VictimNotificationInterface.asp's "Additional
  // Victim Notification Information" section, shown right after Comments,
  // before Victim Notification Attempts).
  // -----------------------------------------------------------------------
  const [victimNotificationExtraFields, setVictimNotificationExtraFields] =
    useState([]);
  const [
    victimNotificationExtraFieldsReady,
    setVictimNotificationExtraFieldsReady,
  ] = useState(false);
  const victimNotificationExtraTypeMapRef = useRef({});
  const victimNotificationExtraIdRef = useRef(0);
  // Only a real, previously-saved notification has this — a locally-added-
  // but-unsaved row only has a client-generated uuid victimNotificationID
  // (see patchVictimData/addNotification), not this.
  const [
    currentVictimNotificationRealId,
    setCurrentVictimNotificationRealId,
  ] = useState(null);

  useEffect(() => {
    api
      .get(`${API_ENDPOINTS.getTableColumns}/VictimNotificationExtra`)
      .then((response) => {
        const tableData = (response?.data || []).filter((d) =>
          d?.columnName?.endsWith("_U")
        );
        const converted = convertApiFields(tableData, "VictimNotificationExtra");
        const typeMap = {};
        converted.forEach((c) => {
          typeMap[c.columnName] = getSQLTypeToHTMLType(c?.type);
        });
        victimNotificationExtraTypeMapRef.current = typeMap;
        setVictimNotificationExtraFields(converted);
        setVictimNotificationExtraFieldsReady(true);
      })
      .catch((error) => {
        console.error(
          "[VictimNotificationDetails] VictimNotificationExtra field defs fetch failed:",
          error
        );
      });
  }, []);

  // Fetches the saved VictimNotificationExtra row when editing an existing
  // notification — a brand new one has no victimNotificationID yet.
  useEffect(() => {
    if (!victimNotificationExtraFieldsReady) return;
    if (!isNonEmptyVariable(currentVictimNotificationRealId)) {
      victimNotificationExtraIdRef.current = 0;
      return;
    }

    fetchExtraTableRecord(
      "VictimNotificationExtra",
      "victimNotificationID",
      currentVictimNotificationRealId
    )
      .then((result) => {
        if (!result) return;
        victimNotificationExtraIdRef.current =
          result.raw?.VictimNotificationExtraID ?? 0;
        const withDates = Object.keys(result.values).reduce((acc, key) => {
          const val = result.values[key];
          const htmlType = victimNotificationExtraTypeMapRef.current[key];
          const isDateField = htmlType === "date" || htmlType === "datetime";
          acc[key] = isDateField && isNonEmptyVariable(val) ? dayjs(val) : val;
          return acc;
        }, {});
        victimNotificationForm.setFieldsValue(withDates);
      })
      .catch((error) => {
        console.error(
          "[VictimNotificationDetails] VictimNotificationExtra fetch failed:",
          error
        );
      });
  }, [currentVictimNotificationRealId, victimNotificationExtraFieldsReady]);

  // VictimNotificationLogExtra field keys/type map/current PK, reported up
  // from VictimNotificationAttemptForm — see the onExtraMetaChange prop
  // passed to it below. Read at save time, not a render input, so a ref is
  // enough.
  const victimLogExtraMetaRef = useRef({ fieldKeys: [], typeMap: {}, extraID: 0 });

  // Local state for personal details (selectedAliases and addresses)
  const [selectedAliases, setSelectedAliases] = useState(
    selectedRow?.jackets?.[0]?.bio?.[0]?.bioAliases || []
  );
  const [addresses, setAddresses] = useState(
    selectedRow?.jackets?.[0]?.bio?.[0]?.bioAddresses || []
  );

  useEffect(() => {
    setShowVictimNotifyTable(bookings?.victimNotifications?.length > 0);
  }, [bookingsFieldsEnabled, bookings?.victimNotifications]);

  useEffect(() => {
    victimNotificationForm.setFieldsValue({ bioAliases: selectedAliases });
  }, [selectedAliases, victimNotificationForm]);

  useEffect(() => {
    victimNotificationForm.setFieldsValue({ bioAddresses: addresses });
  }, [addresses, victimNotificationForm]);

  useEffect(() => {
    setVictimNotifiTableList(
      (bookings?.victimNotifications || [])
        .map((item) => ({ ...item }))
        .sort((a, b) => {
          const idA = Number(a.victimNotificationID) || Number.MAX_SAFE_INTEGER;
          const idB = Number(b.victimNotificationID) || Number.MAX_SAFE_INTEGER;
          return idA - idB;
        })
    );
  }, [bookings?.victimNotifications]);

  useEffect(() => {
    if (selectedRow) {
      let tableData = [...(selectedRow?.victimNotificationLog || [])];
      setVictimLogTable(
        tableData.map((item) => {
          return {
            ...item,
            methodLbl: getOptionsFromRefList(
              "VictimNotification_Method",
              false,
              false,
              true
            )?.filter((data) => data.value == item.method)?.[0]?.label,
            successful: item.successful ? "True" : "False",
          };
        })
      );

      setSelectedAliases(selectedRow?.jackets?.[0]?.bio?.[0]?.bioAliases || []);
      setAddresses(selectedRow?.jackets?.[0]?.bio?.[0]?.bioAddresses || []);
    } else {
      victimNotificationForm.resetFields();
    }
  }, [selectedRow]);

  useEffect(() => {
    if (vicitimLogTable && vicitimLogTable?.length > 0) {
      const lastLog = vicitimLogTable[vicitimLogTable?.length - 1];
      if (lastLog.successful === "True") {
        victimNotificationForm.setFieldsValue({ status: "Notified" });
      } else {
        victimNotificationForm.setFieldsValue({ status: "Not Notified" });
      }
    } else {
      // Optionally, if there are no logs, set a default status.
      victimNotificationForm.setFieldsValue({ status: "Not Notified" });
    }
  }, [vicitimLogTable, victimNotificationForm]);

  const handleNotificationAttemptModal = () => {
    setNotificationAttemptModal(!notificationAttemptModal);
  };
  const clickVictimNotification = (isEdit) => {
    setShowVictimNotification(true);
    if (!isEdit) {
      setTimeout(() => {
        setIsFolderSearchModal(true);
      }, 700);
    }
  };
  const addNotification = () => {
    verification.clearAll();
    victimNotificationForm.setFieldsValue({
      comments: null,
      status: "Not Notified",
      jackets: [
        {
          bio: [
            {
              dlNumber: "",
              dlState: null,
              dlExpiration: null,
              ssn: "",
              dob: null,
              ageAtEntry: "",
            },
          ],
        },
      ],
    });

    // Clear any previous personal information selections.
    setSelectedAliases([]);
    setAddresses([]);
    setSelectedRow(null);
    setVictimNotificationID(null);
    // A stale currentVictimNotificationRealId from a previously-viewed row
    // would otherwise make the VictimNotificationExtra fetch effect above
    // populate this fresh Add form with the old row's extra values.
    setCurrentVictimNotificationRealId(null);
    victimNotificationExtraIdRef.current = 0;
    setVictimLogTable([]);
    clickVictimNotification();
  };
  // Also fires for FolderDetailSearchModal's "Create New Folder" button
  // (same onSaveClick callback) — meta.isNewJacket tells the two apart.
  const handleSelectCurrentJacket = (selectedFolder, meta) => {
    if (!selectedFolder) {
      alert("Please select a folder from the list first.");
      return;
    }
    const folderData = selectedFolder.originalData;
    const associateFromFolder = {
      uuid: folderData?.associatedWithJacketID || uuidv4(),
      associateTypeID: folderData?.associateType,
      jacketID: folderData?.jacketId,
      bioID: folderData?.jackets?.bioId,
      jackets: folderData?.jackets
        ? [folderData?.jackets]
        : [{ staffJacket: false, orphanFlag: false, bio: [selectedFolder] }],
      // Distinguishes this from patchVictimData/viewVictimDetails' "load an
      // existing record" path — only a fresh EXISTING jacket pick needs
      // verification. A brand-new folder (meta.isNewJacket) has nothing to
      // verify against.
      isFreshJacketPick: !meta?.isNewJacket,
    };
    const parsedDOB = folderData?.jackets?.bio?.[0]?.dob
      ? dayjs(folderData?.jackets.bio[0].dob, "MM/DD/YYYY")
      : null;
    const age = parsedDOB ? dayjs().diff(parsedDOB, "year") : "";
    victimNotificationForm.setFieldsValue({
      jackets: [
        {
          bio: [
            {
              dlNumber: folderData?.jackets.bio?.[0]?.dlNumber,
              dlState: folderData?.jackets?.bio?.[0]?.dlState,
              dlExpiration: folderData?.jackets?.bio?.[0]?.dlExpiration
                ? dayjs(folderData?.jackets.bio[0].dlExpiration, "MM/DD/YYYY")
                : null,
              ssn: folderData?.jackets?.bio?.[0]?.ssn,
              dob: parsedDOB,
              ageAtEntry: age,
            },
          ],
        },
      ],
    });

    // These came from the jacket the user just linked, not from typing —
    // pink them out until confirmed. ageAtEntry is excluded: it's a
    // disabled/computed field, same as ASP skips verification on disabled fields.
    // Skip entirely for a "Create New Folder" pick (meta.isNewJacket) — there's
    // no linked jacket to verify these against.
    if (!meta?.isNewJacket) {
      const bio = folderData?.jackets?.bio?.[0];
      const copiedFields = ["dlNumber", "dlState", "dlExpiration", "ssn", "dob"].filter(
        (f) => bio?.[f]
      );
      if (copiedFields.length) verification.markUnverified(copiedFields);
    }

    setSelectedRow(associateFromFolder);
    setIsFolderSearchModal(false);
  };

  const patchVictimData = (item) => {
    verification.clearAll();
    setVictimLogTable([]);
    setSelectedRow(item);
    setVictimNotificationID(item.victimNotificationID || item.id);
    setCurrentVictimNotificationRealId(item?.victimNotificationID || null);
    // If personal details are stored on the item, set them into local state.
    if (item?.jackets?.[0]?.bio?.[0]?.bioAliases) {
      setSelectedAliases(item?.jackets?.[0]?.bio?.[0]?.bioAliases);
    }
    if (item?.jackets?.[0]?.bio?.[0]?.bioAddresses) {
      setAddresses(item?.jackets?.[0]?.bio?.[0]?.bioAddresses);
    }
  };

  const viewVictimDetails = (intData = null) => {
    console.log("intData : ", intData);
    let dataToSet;
    if(intData.victimNotificationID || intData.id) {
      setVictimLogTable([]);
      setSelectedRow(intData);
      setVictimNotificationID(intData.victimNotificationID || intData.id);
      setCurrentVictimNotificationRealId(intData?.victimNotificationID || null);
      dataToSet = {
        ...intData,
        jackets: intData.jackets ? [...intData.jackets] : [],
      };
    }
    else {
      dataToSet = {
        ...selectedRow,
        jackets: selectedRow.jackets ? [...selectedRow.jackets] : [],
      };
    }
    setIsEdit(true);
    // Create a shallow clone of selectedRow, then clone its jackets array if it exists
    

    // If there is at least one jacket, clone its bio array
    if (dataToSet.jackets[0]) {
      dataToSet.jackets[0] = {
        ...dataToSet.jackets[0],
        bio: dataToSet.jackets[0].bio ? [...dataToSet.jackets[0].bio] : [],
      };

      // If there is at least one bio entry, clone and update it
      if (dataToSet.jackets[0].bio[0]) {
        const bioData = { ...dataToSet.jackets[0].bio[0] };

        // Convert the date strings into dayjs objects using the same format
        if (bioData.dlExpiration) {
          bioData.dlExpiration = dayjs(bioData.dlExpiration, "MM/DD/YYYY");
        }
        if (bioData.dob) {
          bioData.dob = dayjs(bioData.dob, "MM/DD/YYYY");
        }

        // Assign the updated bioData back to the new bio array
        dataToSet.jackets[0].bio[0] = bioData;
      }
    }

    // Set the processed values into the form
    victimNotificationForm.setFieldsValue(dataToSet);
    clickVictimNotification(true);
  };

  const saveNotificationLog = () => {
    if (!selectedVictimLog) return;
    setSelectedRow((prev) => {
      // Split VictimNotificationLogExtra's dynamic fields out of
      // selectedVictimLog — reported up from VictimNotificationAttemptForm
      // via onExtraMetaChange (see victimLogExtraMetaRef below). Only keys
      // actually present in selectedVictimLog are pulled out (it's a
      // change-accumulator built field-by-field via onValuesChange, not a
      // full form dump) — an untouched extra field must fall through to
      // the existing saved value below, not get nulled out.
      const { fieldKeys, typeMap, extraID } = victimLogExtraMetaRef.current;
      const existingLogEntry = victimLogID
        ? prev?.victimNotificationLog?.find(
            (p) => p?.id === victimLogID || p?.victimNotificationLogID === victimLogID
          )
        : null;
      const existingExtra = existingLogEntry?.victimNotificationLogExtra?.[0] || {};
      const extraData = {};
      const selectedVictimLogRest = { ...selectedVictimLog };
      fieldKeys.forEach((k) => {
        if (k in selectedVictimLogRest) {
          const val = selectedVictimLogRest[k];
          const htmlType = typeMap[k];
          extraData[k] = val
            ? htmlType === "date" ? dayjs(val).format("MM/DD/YYYY")
              : htmlType === "datetime" ? dayjs(val).format("MM/DD/YYYY HH:mm")
              : val
            : null;
          delete selectedVictimLogRest[k];
        }
      });

      const value = {
        ...selectedVictimLogRest,
        dateNotified: dayjs(
          selectedVictimLogRest.dateTimeNotified || new Date()
        ).format("MM/DD/YYYY"),
        timeNotified: dayjs(
          selectedVictimLogRest.dateTimeNotified || new Date()
        ).format("HH:mm"),
        victimNotificationLogExtra:
          fieldKeys.length > 0
            ? [
                {
                  ...existingExtra,
                  ...extraData,
                  victimNotificationLogExtraID:
                    existingExtra?.victimNotificationLogExtraID ?? extraID ?? 0,
                  victimNotificationLogID:
                    existingExtra?.victimNotificationLogID ?? victimLogID ?? 0,
                },
              ]
            : existingLogEntry?.victimNotificationLogExtra,
      };
      return {
        ...prev,
        victimNotificationLog: victimLogID
          ? prev?.victimNotificationLog.map((p) =>
              p?.id === victimLogID ||
              p?.victimNotificationLogID === victimLogID
                ? value
                : p
            )
          : [
              ...(prev?.victimNotificationLog || []),
              { ...value, id: uuidv4() },
            ],
      };
    });
    handleNotificationAttemptModal();
  };

  const updateFormValue = (field) => {
    const key = Object.keys(field)?.[0];
    setSelectedVictimLog((prev) => ({
      ...prev,
      [key]: field[key],
    }));
  };

  const saveVictimNotification = async () => {
    try {
      const values = await victimNotificationForm.validateFields();
      if (verification.hasUnverifiedFields()) {
        notificationService.error(
          "Please verify all fields copied from the selected record before saving."
        );
        return;
      }
      // Split VictimNotificationExtra dynamic fields out of the form values
      // — nested onto tempData.victimNotificationExtra below rather than
      // left flat on values, where they'd otherwise leak into the main
      // bookings save payload. See pages/Bookings/index.jsx's
      // strip-before-POST and saveVictimNotificationExtra.
      const extraFieldKeys = victimNotificationExtraFields.map(
        (f) => f.columnName
      );
      const extraData = {};
      extraFieldKeys.forEach((k) => {
        const val = values?.[k];
        const htmlType = victimNotificationExtraTypeMapRef.current[k];
        extraData[k] = val
          ? htmlType === "date"
            ? dayjs(val).format("MM/DD/YYYY")
            : htmlType === "datetime"
              ? dayjs(val).format("MM/DD/YYYY HH:mm")
              : val
          : null;
        delete values[k];
      });
      const existingVictimExtra = selectedRow?.victimNotificationExtra?.[0] || {};

      const jacketData = values.jackets?.[0]?.bio?.[0];
      const bio = {
        lName: values.lName,
        fName: values.fName,
        mName: values.mName,
        suffix: values.suffix,
        daytimePhone: values.daytimePhone,
        phone: values.phone,
        bioAliases: values.bioAliases || [],
        bioAddresses: values.bioAddresses || [],
        ...jacketData,
        dlExpiration: jacketData?.dlExpiration
          ? dayjs(jacketData.dlExpiration).format("MM/DD/YYYY")
          : null,
        dob: jacketData?.dob
          ? dayjs(jacketData.dob).format("MM/DD/YYYY")
          : null,
        ageAtEntry: jacketData?.ageAtEntry,
      };

      // Create a jacket object containing the bio information
      const jacket = {
        jacketId: selectedRow?.jacketID, // Use existing jacketId if available
        bioId: selectedRow?.bioID,
        bio: [bio],
      };

      const tempData = {
        ...values,
        victimNotificationLog: selectedRow?.victimNotificationLog,
        jacketID: selectedRow?.jacketID, // Use existing jacketId if available
        bioID: selectedRow?.bioID,
        jackets: [jacket],
        victimNotificationExtra:
          extraFieldKeys.length > 0
            ? [
                {
                  ...existingVictimExtra,
                  ...extraData,
                  victimNotificationExtraID:
                    existingVictimExtra?.victimNotificationExtraID ??
                    victimNotificationExtraIdRef.current ??
                    0,
                  victimNotificationID:
                    existingVictimExtra?.victimNotificationID ??
                    currentVictimNotificationRealId ??
                    0,
                },
              ]
            : selectedRow?.victimNotificationExtra,
      };

      const updatedData = victimNotificationID
        ? victimNotifiTableList.map((p) =>
            p?.victimNotificationID === victimNotificationID ||
            p?.id === victimNotificationID
              ? { ...p, ...tempData }
              : p
          )
        : [...victimNotifiTableList, { ...tempData, id: uuidv4() }];

      updateStorData(updatedData);
      markVictimStepComplete();
      setShowVictimNotification(false);
    } catch (error) {
      console.error(error);
    }
  };

  const addNotificationLog = () => {
    setSelectedVictimLog(null);
    setVictimLogID(null);
    handleNotificationAttemptModal();
  };

  const deleteVictimLog = () => {
    setSelectedRow((prevRow) => ({
      ...prevRow,
      victimNotificationLog:
        prevRow?.victimNotificationLog?.filter(
          (item) =>
            item?.victimNotificationLogID !== victimLogID &&
            item?.id !== victimLogID
        ) || [],
    }));
    setSelectedVictimLog(null);
    setVictimLogID(null);
  };

  const deleteVictimNotify = () => {
    updateStorData(
      victimNotifiTableList.filter(
        (item) =>
          item?.victimNotificationID !== victimNotificationID &&
          item?.id !== victimNotificationID
      )
    );
    const url = API_ENDPOINTS.victimLog + "/id/" + victimNotificationID;
    dispatch(setDeleteAPis(url));
    setVictimNotificationID(null);
    setSelectedRow(null);
  };

  const updateStorData = (tb) => {
    dispatch(
      setBookings({
        victimNotifications: [...tb],
      })
    );
  };

  // Legacy has no automatic validator for the Victims booking-queue step —
  // it's expected to complete as soon as a victim notification is recorded.
  // Stages the completion into Redux the same way the Booking Queue tab's
  // own checkbox/save flow does; actual persistence happens on the overall
  // Bookings save, same as every other booking-queue-detail update.
  const markVictimStepComplete = () => {
    const stepOption = getOptionsFromRefList(
      "BookingQueueStep",
      false,
      false,
      true
    )?.find((opt) => /victim/i.test(opt.label || ""));
    if (!stepOption) return;

    const existingDetails =
      bookings?.bookingsQueue?.[0]?.bookingQueueDetails || [];
    const existingRecord = existingDetails.find(
      (d) => d.queStepID === stepOption.value
    );
    if (existingRecord?.complete === true) return;

    const now = dayjs();
    const updatedRecord = {
      ...existingRecord,
      queStepID: stepOption.value,
      complete: true,
      completionDate: now.format("MM/DD/YYYY"),
      completionTime: now.format("HH:mm"),
      completionStaffID: currentUser?.staffId,
      creatorStaffID: currentUser?.staffId,
    };

    const updatedDetails = existingRecord
      ? existingDetails.map((d) =>
          d.queStepID === stepOption.value ? updatedRecord : d
        )
      : [...existingDetails, updatedRecord];

    dispatch(
      setBookings({
        ...bookings,
        bookingsQueue: [{ bookingQueueDetails: updatedDetails }],
      })
    );
  };

  const cancelAction = () => {
    verification.clearAll();
    setSelectedRow(null);
    setVictimNotificationID("");
    setShowVictimNotification(false);
    setIsEdit(false);
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  useEffect(() => {
    console.log({ isDisabled });
  }, [isDisabled]);
  return (
    <>
      <StyledGridRow justify={"start"}>
        <StyledGridCol xs={12} sm={6} md={6} lg={6}>
          <FormItem
            label="Notify Victims?"
            layout="horizontal"
            className="form-item-checkbox-left"
            valuePropName="checked"
            disabled={
              !bookingsFieldsEnabled || victimNotifiTableList?.length > 0
            }
          >
            <Checkbox
              id="dropletPrecautions"
              disabled={
                !bookingsFieldsEnabled || victimNotifiTableList?.length > 0
              }
              checked={
                showVictimNotifyTable || victimNotifiTableList?.length > 0
              }
              name="Droplet Precautions"
              onChange={(e) => setShowVictimNotifyTable(e?.target?.checked)}
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      {showVictimNotifyTable && (
        <>
          <StyledFlex gap={"10px"} justify="flex-end">
            <Button
              disabled={
                !bookingsFieldsEnabled ||
                isConfiguringVictimNotification ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              onClick={addNotification}
            >
              ADD
            </Button>
            <Button
              disabled={
                !victimNotificationID ||
                victimNotifiTableList?.length === 0 ||
                isConfiguringVictimNotification ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              onClick={viewVictimDetails}
            >
              Details
            </Button>
            <Button
              disabled={
                !victimNotificationID ||
                victimNotifiTableList?.length === 0 ||
                isConfiguringVictimNotification
              }
              onClick={cancelAction}
            >
              Cancel
            </Button>
            <Popconfirm
              title="Delete the VictimNotification"
              description="Are you sure to delete this VictimNotification?"
              onConfirm={deleteVictimNotify}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={
                  !bookingsFieldsEnabled ||
                  !victimNotificationID ||
                  victimNotifiTableList?.length === 0 ||
                  isConfiguringVictimNotification ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.DELETE,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Delete
              </Button>
            </Popconfirm>

            {/* Config — drag-reorder/resize columns; only while Modify is active */}
            {!isConfiguringVictimNotification ? (
              <Button
                htmlType="button"
                onClick={startConfiguringVictimNotification}
              >
                {victimNotificationConfigLabel}
              </Button>
            ) : (
              <Popconfirm
                title="Do you want to save the current list view configuration?"
                onConfirm={confirmSaveVictimNotification}
                onCancel={discardChangesVictimNotification}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button">
                  {victimNotificationConfigLabel}
                </Button>
              </Popconfirm>
            )}
          </StyledFlex>
          {hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report
          ) && (
            <Table
              ref={victimNotificationTableRef}
              headers={shownVictimNotificationHeaders}
              draggable={isConfiguringVictimNotification}
              data={(victimNotifiTableList || []).map((item) => ({
                ...item,
                status: item.status || "",
                lName: item.jackets?.[0]?.bio?.[0]?.lName || "",
                fName: item.jackets?.[0]?.bio?.[0]?.fName || "",
                mName: item.jackets?.[0]?.bio?.[0]?.mName || "",
                daytimePhone: item.jackets?.[0]?.bio?.[0]?.daytimePhone || "",
                phone: item.jackets?.[0]?.bio?.[0]?.phone || "",
                comments: item.comments || "",
              }))}
              style={{ marginTop: "15px" }}
              onRowClick={patchVictimData}
              onRowDoubleClick={(data) => {
                console.log("Double Click");
                patchVictimData(data);
                setTimeout(() => {
                  viewVictimDetails(data);
                }, 100);
              }}
              selected={selectedRow === null}
            />
          )}
        </>
      )}

      {showVictimNotification && (
        <FieldVerificationContext.Provider value={verification}>
        <FieldSecurityProvider
          entity={SCHEMA_NAME.VICTIM_NOTIFICATION}
          startingPoint={startingPoint}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        >
          <Modal
            header={"Victim Notification"}
            show={showVictimNotification}
            size="xl"
            onHide={cancelAction}
            footerActions={[
              {
                key: "save",
                text: "Save",
                onClick: saveVictimNotification,
                disabled: isDisabled || !bookingsFieldsEnabled,
              },
            ]}
            footerCloseAction={() => setIsEdit(false)}
            footerCloseActionText="Close"
          >
            <Form form={victimNotificationForm}>

              <BookingsSectionTitle>
                <span>Personal Information</span>
              </BookingsSectionTitle>

              <VerificationHint />

              <PersonalBasicInformation
                selectedAssociate={selectedRow?.jackets?.[0]?.bio?.[0]}
                fromJacketSearch={!!selectedRow?.isFreshJacketPick}
                form={victimNotificationForm}
                associates={true}
                startingPoint={startingPoint}
              />

              <AliasesList
                showQuickAddForm={false}
                selectedAliases={selectedAliases}
                associates={true}
                onAliasesChange={setSelectedAliases}
                startingPoint={startingPoint}
              />

              <FormItem name="bioAliases" hidden>
                <TextField />
              </FormItem>

              <AddressesList
                selectedAddresses={addresses}
                associates={true}
                onAddressesChange={setAddresses}
                startingPoint={startingPoint}
              />

              <FormItem name="bioAddresses" hidden>
                <TextField />
              </FormItem>

              <StyledGridRow gutter={16}>

                <StyledGridCol>
                  <SecureFormItem
                    fieldName="dlNumber"
                    formItemProps={{
                      label: "Drivers License",
                      name: ["jackets", 0, "bio", 0, "dlNumber"],
                    }}
                  >
                    <TextField />
                  </SecureFormItem>
                </StyledGridCol>

                <StyledGridCol>
                  <SecureFormItem
                    fieldName="dlState"
                    formItemProps={{
                      label: "DL State",
                      name: ["jackets", 0, "bio", 0, "dlState"],
                    }}
                  >
                    <Select
                      options={getOptionsFromRefList("USState")}
                      placeholder="State"
                    />
                  </SecureFormItem>
                </StyledGridCol>

                <StyledGridCol>
                  <SecureFormItem
                    fieldName="dlExpiration"
                    formItemProps={{
                      label: "Expires",
                      name: ["jackets", 0, "bio", 0, "dlExpiration"],
                    }}
                  >
                    <CommonDatePicker format="MM/DD/YYYY" />
                  </SecureFormItem>
                </StyledGridCol>

                <StyledGridCol>
                  <SecureFormItem
                    fieldName="ssn"
                    formItemProps={{
                      label: "SSN",
                      name: ["jackets", 0, "bio", 0, "ssn"],
                    }}
                  >
                    <TextField />
                  </SecureFormItem>
                </StyledGridCol>

                <StyledGridCol>
                  <SecureFormItem
                    fieldName="dob"
                    formItemProps={{
                      label: "DOB",
                      name: ["jackets", 0, "bio", 0, "dob"],
                    }}
                  >
                    <CommonDatePicker disableFutureDates />
                  </SecureFormItem>
                </StyledGridCol>

                <StyledGridCol>
                  <FormItem
                    label="AGE"
                    name={["jackets", 0, "bio", 0, "ageAtEntry"]}
                  >
                    <TextField disabled />
                  </FormItem>
                </StyledGridCol>

              </StyledGridRow>

              <BookingsSectionTitle>
                <span>Notification Information</span>
              </BookingsSectionTitle>

              <StyledGridRow gutter={16}>
                <StyledGridCol>
                  <SecureFormItem
                    fieldName="status"
                    formItemProps={{ label: "Status", name: "status" }}
                  >
                    <TextField />
                  </SecureFormItem>
                </StyledGridCol>
              </StyledGridRow>

              <Row>
                <Col span={8}>
                  <SecureFormItem
                    fieldName="comments"
                    formItemProps={{ label: "Comments", name: "comments" }}
                  >
                    <TextField inputType="textarea" rows="5" />
                  </SecureFormItem>
                </Col>
              </Row>

              {victimNotificationExtraFields.length > 0 && (
                <>
                  <BookingsSectionTitle>
                    <span>Additional Victim Notification Information</span>
                  </BookingsSectionTitle>
                  <StyledGridRow gutter={16}>
                    {victimNotificationExtraFields.map((sf, index) => (
                      <DynamicForm
                        key={index}
                        formAttributes={sf}
                        form={victimNotificationForm}
                        bookingsFieldsEnabled={bookingsFieldsEnabled}
                      />
                    ))}
                  </StyledGridRow>
                </>
              )}

              <BookingsSectionTitle>
              <span>Victim Notification Attempts</span>
            </BookingsSectionTitle>

            <TableHeader>
              <h6>Victim Notification Attempts</h6>
              <div className="right">
                <Button
                  onClick={addNotificationLog}
                  disabled={!bookingsFieldsEnabled || isConfiguringVictimNotificationLog}
                >
                  Add
                </Button>
                <Button
                  disabled={!victimLogID || isConfiguringVictimNotificationLog}
                  onClick={handleNotificationAttemptModal}
                  style={{ marginLeft: "10px" }}
                >
                  Details
                </Button>
                <Popconfirm
                  title="Delete the VictimNotification Log"
                  description="Are you sure to delete this VictimNotification log?"
                  onConfirm={deleteVictimLog}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    color="primary"
                    type="primary"
                    style={{ marginLeft: "10px" }}
                    disabled={
                      !victimLogID ||
                      vicitimLogTable?.length === 0 ||
                      !bookingsFieldsEnabled ||
                      isConfiguringVictimNotificationLog
                    }
                  >
                    Delete
                  </Button>
                </Popconfirm>

                {/* Config — drag-reorder/resize columns; only while Modify is active */}
                {!isConfiguringVictimNotificationLog ? (
                  <Button
                    style={{ marginLeft: "10px" }}
                    htmlType="button"
                    onClick={startConfiguringVictimNotificationLog}
                  >
                    {victimNotificationLogConfigLabel}
                  </Button>
                ) : (
                  <Popconfirm
                    title="Do you want to save the current list view configuration?"
                    onConfirm={confirmSaveVictimNotificationLog}
                    onCancel={discardChangesVictimNotificationLog}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      style={{ marginLeft: "10px" }}
                      htmlType="button"
                    >
                      {victimNotificationLogConfigLabel}
                    </Button>
                  </Popconfirm>
                )}
              </div>
            </TableHeader>

            <Table
              ref={victimNotificationLogTableRef}
              headers={victimNotificationLogHeaders}
              draggable={isConfiguringVictimNotificationLog}
              style={{ padding: "unset" }}
              data={(vicitimLogTable || []).map((row) => ({
                ...row,
                notifyingOfficerStaffID:
                  getOptionsFromRefList("Notifying_Officer", true)?.find(
                    (item) => item.value === row.notifyingOfficerStaffID
                  )?.label || row.notifyingOfficerStaffID,
              }))}
              onRowClick={(data) => {
                setSelectedVictimLog(data);
                setVictimLogID(data?.victimNotificationLogID || data.id);
              }}
              onRowDoubleClick={(data) => {
                setSelectedVictimLog(data);
                setVictimLogID(data?.victimNotificationLogID || data.id);
                handleNotificationAttemptModal();
              }}
            />

            </Form>
          </Modal>
        </FieldSecurityProvider>
        </FieldVerificationContext.Provider>
      )}

      {notificationAttemptModal && (
        <Modal
          header="Victim Notification Attempt"
          show={notificationAttemptModal}
          onHide={handleNotificationAttemptModal}
          size="lg"
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: saveNotificationLog,
            },
          ]}
          footerCloseAction
          footerCloseActionText={"Close"}
        >
          <VictimNotificationAttemptForm
            selectedVictim={selectedVictimLog}
            updateFormValue={updateFormValue}
            onExtraMetaChange={(meta) => {
              victimLogExtraMetaRef.current = meta;
            }}
            startingPoint={startingPoint}
          />
        </Modal>
      )}

      {isFolderSearchModal && (
        <FolderDetailSearchModal
          show={isFolderSearchModal}
          onSaveClick={handleSelectCurrentJacket}
          onHide={() => setIsFolderSearchModal(false)}
        />
      )}
    </>
  );
};

export default VictimNotificationDetails;
